//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import CustomerAccountReceivableListView from '@/views/Sale/SlCustomerAccountReceivable/CustomerAccountReceivableList'

//
export default {
    path: 'pending_account_receivable',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'customer-account-receivable-list',
            component: CustomerAccountReceivableListView,
        },
    ],
    meta: {
        title: 'Documentos por cobrar',
    },
}
